import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable()
export class FingerprintService {
  private fingerprint: string | null = null;

  public async getFingerprint(): Promise<string> {
    if (this.fingerprint) {
      return this.fingerprint;
    }

    const fingerPrintAgent = await FingerprintJS.load();
    const result = await fingerPrintAgent.get();
    this.fingerprint = result.visitorId;

    return this.fingerprint;
  }
}
